import axios from 'axios';

// ============= INTERNET CHECK UTILITIES =============

const checkonline = () => {
  return navigator.onLine;
};

// ============= AXIOS CONFIGURATION =============

const apiaxios = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 1000000,
  withCredentials: true,
});

// ============= REQUEST INTERCEPTOR (INTERNET CHECK) =============
apiaxios.interceptors.request.use(
  (config) => {
    // console.log('Checking internet connection...');


    const isOnline = checkonline();

    if (!isOnline) {
      // console.log('No internet connection detected');


      return Promise.reject({
        response: {
          status: '503',
          message: 'No internet connection. Please connect to the internet.'
        },
        isNetworkError: true
      });
    }

    // console.log('✅ Internet connection verified');
    return config;
  },
  (error) => {
    // console.log('❌ Request interceptor error:', error);
    return Promise.reject({
      response: {
        status: 'request_error',
        message: 'Failed to prepare request'
      }
    });
  }
);

// ============= RESPONSE INTERCEPTOR (ERROR HANDLING) =============
apiaxios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // console.log('❌ Response interceptor caught error:', error);
    // console.log(error.response ? error.response.status : 'No response status');

    // If it's already our custom network error from request interceptor
    if (error.isNetworkError) {
      return Promise.reject(error);
    }

    // Handling server response errors
    if (error.response) {
      const statusCode = error.response.status || error.response.data?.status || 'unknown';

      // Handling HTTP status codes directly
      switch (statusCode) {
        case 429:
          // console.log('⚠️ Rate limit exceeded (429) - Converting to 500 for frontend');
          return Promise.reject({
            response: {
              status: "401",
              message: "something went wrong. Please try again later"
            }
          });

        case 401:
          return Promise.reject({
            response: {
              status: "401",
              message: "Unauthorized access"
            }
          });

        case 419:
          return Promise.reject({
            response: {
              status: "419",
              message: "session expired"
            }
          });
    
        // Handling 500 errors
        default:
          return Promise.reject({
            response: {
              status: "500",
              message: "something went wrong. Please try again later"
            }
          });
      }
    }

    // Handling network/connection errors
    if (error.code) {
      // console.log(`Network error - Code: ${error.code}`);

      switch (error.code) {
        case 'ERR_NETWORK':
        case 'NETWORK_ERROR':
          return Promise.reject({
            response: {
              status: '503',
              message: 'Network connection failed. Please check your internet connection.'
            }
          });

        case 'ECONNABORTED':
        case 'ERR_CANCELED':
          return Promise.reject({
            response: {
              status: '408',
              message: 'Request timeout. Please try again.'
            }
          });

        case 'ERR_CONNECTION_REFUSED':
          return Promise.reject({
            response: {
              status: '503',
              message: 'Connection refused. Server may be down.'
            }
          });

        case 'ERR_BAD_REQUEST':
          return Promise.reject({
            response: {
              status: '500',
              message: 'Bad request. Please check your input.'
            }
          });

        default:
          return Promise.reject({
            response: {
              status: '503',
              message: 'Network error occurred. Please try again.'
            }
          });
      }
    }

    return Promise.reject({ response: { status: "500", message: "something went wrong. Please try again later" } });
  }
);


let isOnlineStatus = navigator.onLine;

window.addEventListener('online', () => {
  // console.log('🟢 Internet connection restored');
  isOnlineStatus = true;
});

window.addEventListener('offline', () => {
  // console.log('🔴 Internet connection lost');
  isOnlineStatus = false;
});


export const getCurrentNetworkStatus = () => navigator.onLine;
export { checkonline };
export default apiaxios;